export default "__VITE_ASSET__C4Z4DolT__"